import "./TextField.scss";

import { FilledTextFieldProps as MUIFilledTextFieldProps, IconButton, InputAdornment, OutlinedTextFieldProps as MUIOutlinedTextFieldProps, StandardTextFieldProps as MUIStandardTextFieldProps, TextField as MUITextField, Typography } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import React, { useState } from "react";

import { Mode } from "../../../utils/utility";

interface BaseTextFieldProps {
  mode: Mode;
  unit?: string;
}

export interface StandardTextFieldProps extends MUIStandardTextFieldProps, BaseTextFieldProps { }
export interface FilledTextFieldProps extends MUIFilledTextFieldProps, BaseTextFieldProps { }
export interface OutlinedTextFieldProps extends MUIOutlinedTextFieldProps, BaseTextFieldProps { }

export type TextFieldProps = StandardTextFieldProps | FilledTextFieldProps | OutlinedTextFieldProps;

export const TextField = (props: TextFieldProps) => {
  const {
    className,
    error,
    id,
    mode,
    type,
    unit,
    value,
  } = props;

  // State
  const [showPassword, setShowPassword] = useState(false);

  // Options
  const computedType = type === "password" && showPassword ? "text" : type;
  const endAdornment = type === "password" ?
    <InputAdornment position="end">
      <IconButton
        className="default"
        aria-label="toggle password visibility"
        onClick={() => setShowPassword(!showPassword)}
      >
        {showPassword ? <VisibilityOff /> : <Visibility />}
      </IconButton>
    </InputAdornment>
    : null;

  switch (mode) {
    case Mode.View:
      return (
        <Typography variant="body1" color="primary" className={className}>
          {value} {unit}
        </Typography>
      );
    case Mode.Edit:
      return (
        <MUITextField
          {...props}
          type={computedType}
          className={"common-text-field " + className}
          name={id}
          helperText={error}
          InputProps={{ endAdornment }}
        />
      );
    default:
      return null;
  }
};

TextField.defaultProps = {
  mode: Mode.Edit,
  variant: "outlined",
}
